import React from 'react';
import OverzichtPortfolios from '../../components/portfolios/Overzicht';

const PagePortfolioOverzicht: React.FC = () => {

  return (
    <>
      <header className="app-header">
        <h1>Mijn afstemmingdossiers</h1>
        <p className="header-sub-title center">
          Overzicht van alle afstemmingdossiers waarin u deelneemt.
        </p>
      </header>

      <div className="content">
        <OverzichtPortfolios />
      </div>
    </>
  );
};

export default PagePortfolioOverzicht;